export default __webpack_public_path__ + "static/media/tachometer-fast.a2677bf0.svg";